import React, { FunctionComponent, useCallback, useState } from 'react';
import { useStore } from 'effector-react';

import IUser from '@interfaces/IUser';
import reasons, {
  getList as getComplaintReasons,
  reset as resetComplaintReasons,
} from '@stores/complaints-reason';
import ComplaintsReasons from '@components/SpamUserCard/ComplaintsReasons/ComplaintsReasons';

interface UserClaimsTriggerProps {
  user?: IUser | null;
  complaintsByReason?: Array<{
    reason?: string;
    complaints?: number;
  }>;
}

const UserClaimsTrigger: FunctionComponent<UserClaimsTriggerProps> = ({
  user,
  complaintsByReason = [],
}) => {
  const { preloaders } = useStore(reasons);
  const [reasonsTable, setReasonsTable] = useState<any[]>([]);

  const handleReasonTableOpen = useCallback(
    (value: boolean) => {
      if (!value || !user?.id) return;

      resetComplaintReasons();
      getComplaintReasons(user.id).then(({ data }) => {
        setReasonsTable(data?.body?.result?.page || []);
      });
    },
    [user?.id],
  );

  const filteredComplaintsByReason = Array.isArray(complaintsByReason)
    ? complaintsByReason.filter((item) => item?.reason)
    : [];

  return (
    <>
      {filteredComplaintsByReason.length > 0 && (
        <div>
          {filteredComplaintsByReason.map((item, index) => (
            <div key={`${item.reason}-${index}`}>
              <span>{item.reason}:</span> <span>{item.complaints || 0}</span>
            </div>
          ))}
        </div>
      )}

      <ComplaintsReasons
        reasonsTable={reasonsTable}
        isLoading={!!preloaders.getList}
        onOpen={handleReasonTableOpen}
        user={user}
      />
    </>
  );
};

export default UserClaimsTrigger;
